export default {
  path: '/',
  name: 'system',
  component: () => import('@/layouts/BaseLayout'),
  children: [],
}